import { render, staticRenderFns } from "./MenuFormCard.vue?vue&type=template&id=b62c9156&"
import script from "./MenuFormCard.vue?vue&type=script&lang=ts&"
export * from "./MenuFormCard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports